import { Item } from "@dto/records";
import { TW_TextCell, TW_TextCell_editing } from "@utils/twClasses";
import { RefObject, useEffect, useState } from "react";
import { useModelStore, useUserStore } from "src/store";
import { AbstractCell } from "./AbstractCell";
import { CellProps } from "./GridCell";
import { EditRightAccess, hasGlobalRightAccess, ObjectRightType, ViewRightType } from "@dto/Users";
import { useTranslation } from "react-i18next";
import { replaceI18n } from "src/i18n/i18n";
import { displayText } from "@utils/types";

export function TextCell({ pathKey, field, item, position, updateValue, isEditing, inputRef, blurTriggered }: CellProps) {

    const [text, setText] = useState(item ? item.value || "" : "");
    const {t} = useTranslation();
    const wsColor = useModelStore(state => state.wsColor);
    const [lastBlurTriggered, setLastBlurTriggered] = useState<number | null>(null);
    const userRole = useModelStore(state => state.userRole);
    const user = useUserStore(state => state.user);
    const selectedObjectInfos = useModelStore(state => state.selectedObjectInfos);
    const selectedView = useModelStore(state => state.selectedView);
    const hasEditAccessOnObject = hasGlobalRightAccess(user, userRole, ObjectRightType, EditRightAccess, selectedObjectInfos?.object?._key);
    const hasEditAccessOnView = hasGlobalRightAccess(user, userRole, ViewRightType, EditRightAccess, selectedView?._key);
    const hasEditAccess = hasEditAccessOnObject && hasEditAccessOnView;
    const readOnly = item.readOnly || !hasEditAccess ;
    const format = selectedView?.formats?.get(pathKey ?? "") ?? field?.format;
    // console.log("Rendering TextCell", posToString(position) + " - " + text, item?.value);

    useEffect(() => {
        if (item?.value !== text) {
            setText(item ? item.value || "" : "");
        }
    }, [item]);
    
    useEffect(() => {
        const newValue = textToValue(text);
        if (isEditing && lastBlurTriggered && blurTriggered && lastBlurTriggered !== blurTriggered && item?.value !== newValue) {
            updateValue(item, newValue);
        }
        setLastBlurTriggered(blurTriggered);
    }, [blurTriggered]);

    const updateLocalValue = (item: Item, value: any) => {
        setText(value || "");
        updateValue(item, value);
    }

    const textToValue = (text: string | null): any => {
        return text;
    }

    function isTextValid(value: string | null) {
        return true;
    }

    const renderReadOnlyContent = () => {
        let value = text;
        if (field.formula && field.formula.length > 0 && value.includes("$i18n")) {
            value = replaceI18n(t, value);
        }
        const displayed = displayText(value, format);
        return (
            <div className={TW_TextCell + (field.name ? " " : " text-center ") + (readOnly ? " cursor-not-allowed" : "")}>
                {displayed}
            </div>
        )
    }

    const renderEditingContent = (
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        onEnterKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void,
        inputRef: RefObject<HTMLInputElement>
    ) => {
        return (
            <input
                className={TW_TextCell_editing}
                type="text"
                value={text ?? ""}
                onChange={onTextChange}
                onKeyDown={onEnterKeyPress}
                autoFocus={true}
                style={{ borderColor: wsColor }} 
                ref={inputRef}
            />
        )
    }

    return <AbstractCell
        item={item}
        position={position}
        updateValue={updateLocalValue}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        text={text}
        setText={setText}
        isEditing={isEditing}
        inputRef={inputRef}
        readOnly={readOnly}
    />
}
